import { render } from "./PublicServices.vue?vue&type=template&id=61b6964c"
import script from "./PublicServices.vue?vue&type=script&lang=js"
export * from "./PublicServices.vue?vue&type=script&lang=js"

import "./PublicServices.vue?vue&type=style&index=0&id=61b6964c&lang=css"

import exportComponent from "C:\\MesProjets\\Labs\\akdevmatik\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__